import { setTheme } from "theme/default/setTheme";

export const setFontSize_18px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_18px}`);
